import type { Fallacy } from "./types";
import { createStory } from "./types";

export const decoyEffect: Fallacy = {
    id: "decoy-effect",
    name: "Decoy Effect",
    emoji: "🎯",
    category: "Otak yang Menipu Diri",
    description: "**Opsi ketiga** yang sengaja inferior ditambahkan agar opsi lain terlihat **jauh lebih worth it**.",
    tldr: "Paket Medium ada bukan buat dibeli, tapi buat bikin paket Large keliatan murah.",
    detail: "Decoy Effect adalah fenomena di mana preferensi antara dua opsi berubah ketika **opsi ketiga yang \"inferior\" ditambahkan**. Decoy ini sengaja dirancang agar tidak dipilih, tapi **kehadirannya mengubah persepsi kita** terhadap opsi lainnya.\n\nContoh klasik: The Economist menawarkan (A) Digital — $59, (B) Print — $125, (C) Print + Digital — $125. **Opsi B adalah decoy** — tanpa B banyak orang pilih A, tapi dengan adanya B, mayoritas beralih ke C karena terasa \"worth it banget.\"\n\nBisnis menggunakan strategi ini karena dengan menambahkan satu opsi yang **secara strategis inferior**, mereka bisa mengarahkan konsumen ke opsi yang paling menguntungkan.\n\nCara melawan: **Evaluasi setiap opsi secara independen**. Tanya: \"Apakah ini worth it dengan sendirinya?\"",
    story: createStory("Decoy Effect", "🎯", {
      hook: {
        title: "Pernah pilih paket Large?",
        body: "\"Beda 3 ribu doang sama Medium, ya Large lah!\" — Tapi... emang butuh Large?",
      },
      convo: {
        claim: "Cloud storage Basic 50GB 30rb, Plus 200GB 89rb, Pro 2TB 99rb. **Beda 10rb dari Plus tapi dapet 10x lipat**, jelas Pro dong.",
        response: "Kebutuhan kamu cuma 50GB. **Plus ada buat bikin Pro keliatan worth it.**",
      },
      reveal: {
        body: "Opsi tengah itu **sengaja dipasang biar gak dipilih**. Fungsinya cuma satu: bikin opsi yang lebih mahal keliatan **\"worth it banget\"**.",
      },
      insight: {
        title: "Kamu ngerasa \"menang\"",
        body: "Padahal kamu **diarahin**. Opsi tengah itu cuma umpan biar kamu auto pilih yang paling mahal tanpa mikir butuh atau nggak.",
      },
      engagement: {
        title: "Pernah ketipu Decoy Effect di mana? 🎯",
        body: "Paket kopi, langganan streaming, atau cloud storage? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["framing-effect", "anchoring-bias", "loss-aversion", "appeal-to-emotion"],
  };
